import { useNavigation } from '@react-navigation/native'
import { useSelector } from 'APP/Hooks/redux'
import Analytics from 'APP/Services/Analytics'

import Button from 'APP/Converse/Button'
import i18n from 'APP/I18n'
import { selectFeatures } from 'APP/Sagas/FeaturesSaga'
import { getLatestEpisode } from 'APP/Store/Journey/helpers'
import { ActionContainer, CardText, CareJourneyHeader, Wrapper } from './style'

const JourneyCard = () => {
  const navigation = useNavigation()

  const { enableCareJourneyScreen } = useSelector(selectFeatures)

  //HACK: get a random episode until we know how to choose which journey to continue
  const episode = useSelector(getLatestEpisode)

  if (!enableCareJourneyScreen || !episode) return null

  const navigateToJourney = () => {
    Analytics.trackEvent('button_click', { button_value: 'TodayScreen.journey' })
    navigation.navigate('journeyScreen', { id: episode.id })
  }

  return (
    <Wrapper>
      <CareJourneyHeader variant="h3">{i18n.t('JourneyScreen.title')}</CareJourneyHeader>
      <ActionContainer analyticsName="journeyScreen" testID="JOURNEY_SCREEN">
        <CardText align="center">
          {i18n.t('TodayScreen.journeyCard.body', { 0: episode.healthIssueTypeId })}
        </CardText>
        <Button
          variant="oomph"
          title={i18n.t('TodayScreen.journeyCard.cta')}
          onPress={navigateToJourney}
          testID="NAV_TO_CARE_JOURNEY"
        />
      </ActionContainer>
    </Wrapper>
  )
}

export default JourneyCard
